import { Alert, AlertColor, AlertTitle, Snackbar } from '@mui/material';
import React, { useState } from 'react';
import { useEffectSkipFirst } from 'utils/hooks/index';

export type NotificationSnackbarProps = {
  notificationMessage: {
    colorType?: AlertColor;
    title?: string;
    body: string;
  };
};

export const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  notificationMessage = {
    colorType: 'success',
    title: '',
    body: '',
  },
}: NotificationSnackbarProps) => {
  const [open, setOpen] = useState(false);

  useEffectSkipFirst(() => {
    if (notificationMessage.body.length > 0) {
      setOpen(true);
    }
  }, [notificationMessage]);

  const handleCloseSnackbar = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={open}
      autoHideDuration={6000}
      onClose={handleCloseSnackbar}
      className="notification-snackbar"
    >
      <Alert variant="filled" severity={notificationMessage.colorType}>
        {notificationMessage.title && notificationMessage.title.length > 0 && (
          <AlertTitle>{notificationMessage.title}</AlertTitle>
        )}
        {notificationMessage.body}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar;
